import React from "react"

import Tags from "../components/tags";
import Social from "../components/social";
import './article-list.css'
import DateFormatter from '../components/date-formatter'
import { Link } from 'gatsby';

const ArticleList = ({tag, articles, paginator}) => (
  <>
      <br/>
    <h4
    className="title"
    >ARCHIVIO {tag ? ('/ '+tag) : ''}</h4>
    <div>
    <div className="archivioArticles">
    {
        articles.map((elem, id) => {
            return <Link className="articleArchivioPrev" to={'/post/'+elem.node.frontmatter.slug} style={{textDecoration: 'none', color: 'hsla(0, 0%, 0%, 0.8)'}}>
            <div className="articleImage"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="imageArchivio"
                style={{
                  backgroundImage: `url(${elem.node.frontmatter.thumbnail})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: 'center',
                  width: '100%',
                  backgroundSize: 'cover'
                }}
              >
              </div>
            </div>
            <div className="articleArchivioContent">
              <div class="articlePrevAuthor">
                <DateFormatter date={elem.node.frontmatter.date} /> - {elem.node.frontmatter.author}
              </div>
              <h3 class="articlePrevTitle">
                {elem.node.frontmatter.title}
              </h3>
              
            </div>
           
            </Link>;
          })
    }
    { paginator && <div style={{textAlign: 'center', width:'100%'}}>{paginator()}</div> }
    </div>



    </div></>
    
)

export default ArticleList
